"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gettextFilters = void 0;
const _ = __importStar(require("lodash"));
function gettextFilters(translate) {
    if (!translate) {
        translate = window.$translate;
        if (!translate) {
            console.warn('Missing GettextTranslate instance on window.');
        }
    }
    return {
        gettext(msgid, conversion, args) {
            if (_.isNull(msgid) || _.isUndefined(msgid)) {
                return '';
            }
            if (!_.isString(msgid)) {
                return msgid;
            }
            return translate && translate.translate({ msgid, conversion, args });
        },
        ngettext(msgid, plural, n, conversion, args) {
            if (_.isNull(msgid) || _.isUndefined(msgid)) {
                return '';
            }
            if (!_.isString(msgid)) {
                return msgid;
            }
            return (translate && translate.translate({ msgid, plural, n, conversion, args }));
        },
        pgettext(msgid, context, conversion, args) {
            if (_.isNull(msgid) || _.isUndefined(msgid)) {
                return '';
            }
            if (!_.isString(context)) {
                throw new Error(`pgettext: missing context parameter. (msgid=${msgid})`);
            }
            return (translate && translate.translate({ msgid, context, conversion, args }));
        },
        npgettext(msgid, plural, context, n, conversion, args) {
            if (_.isNull(msgid) || _.isUndefined(msgid)) {
                return '';
            }
            if (!_.isString(context)) {
                throw new Error(`pgettext: missing context parameter. (msgid=${msgid})`);
            }
            return (translate &&
                translate.translate({
                    msgid,
                    context,
                    conversion,
                    plural,
                    n,
                    args,
                }));
        },
        _(msgid) {
            return translate && translate.translate({ msgid });
        },
        P_(context, msgid) {
            return translate && translate.translate({ msgid, context });
        },
        N_(msgid, plural, n) {
            return translate && translate.translate({ msgid, plural, n });
        },
    };
}
exports.gettextFilters = gettextFilters;
//# sourceMappingURL=filters.js.map